/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: nJ1Nn58LcfAm7wemZm71QH
// Component: -30peDirAMTZ
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/projectcss
import sty from "./PlasmicAwHeaderContent.module.css"; // plasmic-import: -30peDirAMTZ/css

createPlasmicElementProxy;

export const PlasmicAwHeaderContent__VariantProps = new Array("type");

export const PlasmicAwHeaderContent__ArgProps = new Array("title");

const $$ = {};

function PlasmicAwHeaderContent__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          title: "titleDefault"
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "type",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.type
      }
    ],

    [$props, $ctx, $refs]
  );
  const currentUser = useCurrentUser?.() || {};
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_nJ1Nn58LcfAm7wemZm71QH",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      <div className={classNames("all", "__wab_text", sty.text__gsdI5)}>
        <React.Fragment>
          {(() => {
            try {
              return $props.title;
            } catch (e) {
              if (
                e instanceof TypeError ||
                e?.plasmicType === "PlasmicUndefinedDataError"
              ) {
                return "title";
              }
              throw e;
            }
          })()}
        </React.Fragment>
      </div>
      <div
        data-plasmic-name={"crumb1Wrapper"}
        data-plasmic-override={overrides.crumb1Wrapper}
        className={classNames("all", sty.crumb1Wrapper, {
          [sty.crumb1Wrappertype_titleAndAvatar]: hasVariant(
            $state,
            "type",
            "titleAndAvatar"
          ),
          [sty.crumb1Wrappertype_title]: hasVariant($state, "type", "title")
        })}
      >
        <div className={classNames("all", "__wab_text", sty.text__q1UmG)}>
          {"/"}
        </div>
        <div className={classNames("all", "__wab_text", sty.text__umk4Q)}>
          {"crumb1"}
        </div>
      </div>
      <div
        data-plasmic-name={"crumb2Wrapper"}
        data-plasmic-override={overrides.crumb2Wrapper}
        className={classNames("all", sty.crumb2Wrapper, {
          [sty.crumb2Wrappertype_titleAndAvatar]: hasVariant(
            $state,
            "type",
            "titleAndAvatar"
          ),
          [sty.crumb2Wrappertype_titleAndCrumb1]: hasVariant(
            $state,
            "type",
            "titleAndCrumb1"
          ),
          [sty.crumb2Wrappertype_title]: hasVariant($state, "type", "title")
        })}
      >
        <div
          className={classNames("all", "__wab_text", sty.text__oKpKa, {
            [sty.texttype_title__oKpKaRkx9S]: hasVariant(
              $state,
              "type",
              "title"
            )
          })}
        >
          {"/"}
        </div>
        <div className={classNames("all", "__wab_text", sty.text__vwIFu)}>
          {"crumb2"}
        </div>
      </div>
      <div
        data-plasmic-name={"avatarWrapper"}
        data-plasmic-override={overrides.avatarWrapper}
        className={classNames("all", sty.avatarWrapper, {
          [sty.avatarWrappertype_titleAndAvatar]: hasVariant(
            $state,
            "type",
            "titleAndAvatar"
          ),
          [sty.avatarWrappertype_titleAndCrumb1]: hasVariant(
            $state,
            "type",
            "titleAndCrumb1"
          ),
          [sty.avatarWrappertype_titleAndCrumb2]: hasVariant(
            $state,
            "type",
            "titleAndCrumb2"
          ),
          [sty.avatarWrappertype_title]: hasVariant($state, "type", "title")
        })}
      >
        <div
          className={classNames("all", "__wab_text", sty.text__aEpfz, {
            [sty.texttype_title__aEpfzRkx9S]: hasVariant(
              $state,
              "type",
              "title"
            )
          })}
        >
          {"/"}
        </div>
        <div
          data-plasmic-name={"frame596"}
          data-plasmic-override={overrides.frame596}
          className={classNames("all", sty.frame596)}
        >
          <div
            data-plasmic-name={"cV1Final1"}
            data-plasmic-override={overrides.cV1Final1}
            className={classNames("all", sty.cV1Final1)}
          />
        </div>
        <div className={classNames("all", "__wab_text", sty.text__tUqMe)}>
          {"cristian popa"}
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "crumb1Wrapper",
    "crumb2Wrapper",
    "avatarWrapper",
    "frame596",
    "cV1Final1"
  ],

  crumb1Wrapper: ["crumb1Wrapper"],
  crumb2Wrapper: ["crumb2Wrapper"],
  avatarWrapper: ["avatarWrapper", "frame596", "cV1Final1"],
  frame596: ["frame596", "cV1Final1"],
  cV1Final1: ["cV1Final1"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicAwHeaderContent__ArgProps,
          internalVariantPropNames: PlasmicAwHeaderContent__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicAwHeaderContent__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicAwHeaderContent";
  } else {
    func.displayName = `PlasmicAwHeaderContent.${nodeName}`;
  }
  return func;
}

export const PlasmicAwHeaderContent = Object.assign(
  // Top-level PlasmicAwHeaderContent renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    crumb1Wrapper: makeNodeComponent("crumb1Wrapper"),
    crumb2Wrapper: makeNodeComponent("crumb2Wrapper"),
    avatarWrapper: makeNodeComponent("avatarWrapper"),
    frame596: makeNodeComponent("frame596"),
    cV1Final1: makeNodeComponent("cV1Final1"),
    // Metadata about props expected for PlasmicAwHeaderContent
    internalVariantProps: PlasmicAwHeaderContent__VariantProps,
    internalArgProps: PlasmicAwHeaderContent__ArgProps
  }
);

export default PlasmicAwHeaderContent;
/* prettier-ignore-end */
